<template>
	<div class="supply-chain container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="hasPageChild==0">
			
		</div>
	</div>

</template>

<script>
import ListItem from '@/views/pages/ListItem.vue'
import Support from '@/components/page/Support.js'
import BarCard from '@/views/pages/BarCard.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'

export default{
	extends: Support,
	components:{
	
    },
    mounted(){
	
    },
	data() {
		return {
			loading: {
				table: false,
			},
			reportdata: [],
		}
	},
	watch: {

	},
    methods:{	
		
    },
}
</script>
<style>
.home.row1,.home.row2{ height: 300px;}
.text-merah{ color:#c7251c }
.text-biru{ color:#066fb1   }
.text-hijau{ color:#acc437  }
</style>